// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import axios from 'axios'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import Router from 'vue-router'
import router from './router'
import store from './store'
import {utils} from './components/comn/js/utils'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import VueParticles from 'vue-particles'
// import 'quill/dist/quill.bubble.css'
import i18n from './language/i18n.js'
import './assets/AlibabaSans/font.css'
import moment from 'moment'

Vue.use(VueQuillEditor)
Vue.use(ElementUI)
Vue.use(Router)
Vue.use(VueParticles)
Vue.prototype.$http = axios
Vue.config.productionTip = false
Vue.prototype.utils = utils
Vue.prototype.$moment = moment

// var CancelToken = axios.CancelToken
// 超时时间
axios.defaults.timeout = 10000000
// axios配置过滤
axios.interceptors.request.use(config => {
  // console.log(['config', config])
  // 判断请求地址是否需要登录验证
  // if (config.url) {
  // if (localStorage.getItem('currAcct')) {
  // }
  // }
  // if (!('loginType' in config.data)) {
  //   config.data.loginType = 3
  // }
  var loginToken = localStorage.getItem('loginToken')
  config.headers['token'] = loginToken
  return config
}, error => {
  return Promise.reject(error)
})
axios.interceptors.response.use(
  response => {
    if (response.data.code === 2) {
      // if (response.config.url.indexOf('login.htm') !== -1) {
      Vue.prototype.$alert(i18n.t('Login timeout, please log in again!'), i18n.t('change.Tips'), {
        confirmButtonText: i18n.t('orderPolicy.Confirm'),
      }).then(() => {
        // router.push({path: '/login'})
        localStorage.clear()
        location.replace('/login')
      })
      // }
    }
    return response
  },
  error => {
    return Promise.reject(error)
  }
)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location)
}
// vue router配置过滤
router.beforeEach((to, from, next) => {
  let pa = to.path.substring(1, 3)
  if (to.path !== '/login' && to.path !== '/forgotPassword' && pa !== 'h5') {
    if (localStorage.getItem('currAcct')) {
      next()
    } else {
      localStorage.clear()
      localStorage.setItem('referrer', to.path)
      localStorage.setItem('query', JSON.stringify(to.query))
      next({path: '/login'})
    }
  } else {
    var loginToken = localStorage.getItem('loginToken')
    var currAcct = JSON.parse(localStorage.getItem('currAcct'))
    if (loginToken) {
      console.log('1', currAcct.aType)
      if (currAcct.aType !== 1) {
        next({path: '/homePage'})
      } else {
        next({path: '/flightSearch'})
      }
    } else {
      next()
    }
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  i18n,
  render: h => h(App),
  template: '<App/>',
  data: {
    componentstate: new Vue()
  },
  methods: {
    sayHi () {
      alert('')
    }
  },
  created () {
    this.$store.commit('update_menu_list', JSON.parse(localStorage.getItem('menu')))
  }
})



// WEBPACK FOOTER //
// ./src/main.js